export default "<p>\n  tricks-won-tracker works!\n</p>\n"